package com.essntl.features.category.domain.usecase

import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.category.domain.repository.CategoryRepository
import org.koin.core.annotation.Single

@Single
class AddEditCategoryUseCase(
    private val categoryRepository: CategoryRepository,
) {
    private suspend fun performCategoryCheck(
        category: CategoryModel,
        call: suspend () -> Result<CategoryModel>,
    ): Result<CategoryModel> {
        val categoryExists = categoryRepository
            .getCountCategoriesByName(category.name)
            .getOrNull()?.toInt()

        if (categoryExists != 0)
            return Result.failure(Exception("This category is already added, please add a new one."))

        val response = call()

        return response
    }

    suspend fun insertCategory(
        category: CategoryModel,
    ): Result<CategoryModel> =
        performCategoryCheck(category) {
            categoryRepository.insert(category)
        }

    suspend fun updateCategory(
        category: CategoryModel,
    ): Result<CategoryModel> =
        performCategoryCheck(category) {
            categoryRepository.update(category)
        }
}